import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
// Assets
import ContactImg1 from "../../assets/img/add/four4.png";
import ContactImg2 from "../../assets/img/projects/4four.png";
import ContactImg3 from "../../assets/img/projects/2two.png";

import { useToast } from '@chakra-ui/react'

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [desc, setDesc] = useState("");

  const toast = useToast();


  const handleSubmit = ()=>{
    const formData = {
      name:name,
      email:email,
      subject:subject,
      desc:desc
    }
    axios
      .post("https://glb-api.onrender.com/queries/new", formData)
      .then((res) => {
        console.log("sent successfully" + JSON.stringify(formData));
        toast({
          title: "Message Sent",
          description: "We will reply to you shortly.",
          status: "success",
          duration: 5000,
          isClosable: true
        });
        setName("");
        setEmail("");
        setSubject("");
        setDesc("");
      })
      .catch((err) => {
        console.log(err);
        toast({
          title: "Error",
          description: "Failed to send message.",
          status: "error",
          duration: 5000,
          isClosable: true
        });

      });

      // window.alert("sent successfully");
  }
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <label className="font13">First name:</label>
                <input type="text" id="fname" name="fname" className="font20 extraBold" value={name} onChange={(e) => setName(e.target.value)}/>
                <label className="font13">Email:</label>
                <input type="text" id="email" name="email" className="font20 extraBold" value={email} onChange={(e) => setEmail(e.target.value)}/>
                <label className="font13">Subject:</label>
                <input type="text" id="subject" name="subject" className="font20 extraBold" value={subject} onChange={(e) => setSubject(e.target.value)}/>
                <textarea rows="4" cols="50" type="text" id="message" name="message" className="font20 extraBold" value={desc} onChange={(e) => setDesc(e.target.value)}/>
              </Form>
              <SumbitWrapper className="flex">
                <ButtonInput type="submit" value="Send Message" className="pointer animate radius8" style={{ maxWidth: "220px" }} onClick={handleSubmit}/>
              </SumbitWrapper>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div style={{ width: "50%" }} className="flexNullCenter flexColumn">
                <ContactImgBox>
                  <img src={ContactImg1} alt="office" className="radius6" />
                </ContactImgBox>
                <ContactImgBox>
                  <img src={ContactImg2} alt="office" className="radius6" />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img src={ContactImg3} alt="office" className="radius6" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #2E8BC0;
  background-color: #2E8BC0;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #145DA0;
    border: 1px solid #2E8BC0;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;









